import { Link } from 'react-router-dom';
import { articles, categories } from '@/mocks/data';

export default function LatestSection() {
  const latest = [...articles]
    .sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime())
    .slice(0, 8);

  const getCategoryName = (slug: string) =>
    categories.find((c) => c.slug === slug)?.name || slug;

  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              最新内容
            </h2>
            <p className="text-foreground-600 text-sm">持续更新，不错过任何精彩</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {latest.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-100 rounded-xl overflow-hidden hover:bg-background-100 transition-all duration-300"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute bottom-3 left-3">
                  <span className="px-2.5 py-1 bg-black/60 backdrop-blur-sm text-white text-xs font-label rounded-full whitespace-nowrap">
                    {getCategoryName(article.category)}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading font-semibold text-foreground-950 text-sm mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{article.publishDate}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                    {article.rating}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}